import OBTFileView from './OBTFileView';

export default OBTFileView;


